<div class="download-template-modal" *transloco="let t; prefix: 'assetShared.downloadTemplate'">

  <div class="download-template-modal__header">
    <div>
      <h5 class="download-template-modal__title">{{ title || t('title') }}</h5>
      <p class="download-template-modal__subtitle">{{ subtitle || t('subtitle') }}</p>
    </div>
    <button class="download-template-modal__close" (click)="close()">
      <i class="ph ph-x"></i>
    </button>
  </div>

  <div class="download-template-modal__body">
    <img class="download-template-modal__image" [src]="imageSrc" [alt]="imageAlt || t('imageAlt')">
  </div>

  <div class="download-template-modal__footer">
    <button class="cancel-btn" (click)="close()">{{ 'common.cancel' | transloco }}</button>
    <button class="download-btn" (click)="download()">{{ t('download') }}</button>
  </div>

</div>
